const MULTI_ST_REGEX = /^([^.]+)?env\d+\.st-app\.pirumconnect\.com/g;
const TOGGLE_NEW_SSO = MULTI_ST_REGEX.test(window.location.host) ? "true" : "false";

export { TOGGLE_NEW_SSO };
